import { Injectable, Inject } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { Sector } from './sector.model';

@Injectable()
export class SectorResolver implements Resolve<Sector> {
  constructor(
    protected router: Router,
    protected snackService: SnackService,
    protected backendService: BackendService,
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const id = route.params.id || 'agregar';

      if (id === 'agregar') {
        return this.backendService.new(Sector);
      }
      return await this.backendService.get(Sector, Sector.path + id).toPromise();
    } catch (error) {
      this.router.navigate(['/sectores']);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/cliente/sectores/sector.resolver.ts